export default class ComponentExportModel {
    pathToFile: string
    base64Encoded: string
}
